module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.285a9d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-regular-400.ttf
// module id = 339
// module chunks = 1